import getInitial from './getInitial';
import getTextBoyColor from './getTextBoyColor';
import PersonaBlob, { PersonaBlobFetchStatus } from '../store/schema/PersonaBlob';
import PersonaControlViewState from '../store/schema/PersonaControlViewState';
import { PersonaSize } from 'fabric-persona';

const mapPersonaToPersonaViewState = (
    name: string,
    emailAddress: string,
    personaId: string,
    initialGenerationText: string,
    personaSize: PersonaSize
): PersonaControlViewState => {
    const personaBlob: PersonaBlob = {
        blobUrl: null,
        FetchStatus: PersonaBlobFetchStatus.None,
    };

    return {
        name,
        emailAddress,
        personaId,
        personaBlob,
        personaSize,
        initials: getInitial(initialGenerationText),
        textBoyColor: getTextBoyColor(name),
    };
};

export default mapPersonaToPersonaViewState;
